export default {"src":"/_next/static/media/Strapline.73cfd8d1.svg","height":45,"width":110,"blurWidth":0,"blurHeight":0};